export default __webpack_public_path__ + "static/png-assets-06-e0d523327efab563d4e79bc14373e87e.png";